<template>
  <ul class="m-miniTabs">
    <li :class="{'z-active' : isActive(item)}" v-for="item in tabs" :key="item.vule" @click="setCurrent(item)">{{ item.name }}</li>
  </ul>
</template>

<script>
export default {
  name: 'MiniTabs',
  props: {
    value: {
      require: !0,
    },
    tabs: {
      type: Array,
      require: !0,
    },
  },
  methods: {
    setCurrent(item) {
      this.$emit('input', item.value);
    },
    isActive(item) {
      return item.value === this.value;
    },
  },
};
</script>

<style lang="less" scoped>
  .m-miniTabs {
    text-align: left;
    > li {
      display: inline-block;
      font-size: 12px;
      line-height: 17px;
      color: white;
      margin-right: 40px;
      position: relative;
      padding: 5px 0;
      cursor: pointer;
      &.z-active {
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          margin-left: -22px;
          bottom: 0;
          width: 45px;
          height: 3px;
          background-color: white;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/mini_tabs/mini_tabs.vue